import { Agentation } from "agentation"
import React from "react"
import ReactDOM from "react-dom/client"
import { BrowserRouter } from "react-router-dom"
import { App } from "./App.tsx"
// design tokens 먼저 → 레이아웃/컴포넌트 → 테이블/탭 → 매트릭스/플레이그라운드 순으로 import.
// 분리 기준은 domain 이 아니라 cascade 순서 (tokens 가 제일 먼저 정의되어야 다른 파일이 --pk-* 를 참조 가능).
// assistant-ui-theme 은 tokens 직후에 — 채팅 base 스타일이 페이지별 CSS 보다 앞서 정의되도록.
import "./styles/tokens.css"
import "./styles/assistant-ui-theme.css"
import "./styles/layout.css"
import "./styles/components.css"
import "./styles/tables-tabs.css"
import "./styles/matrix.css"
import "./styles/ontology.css"
import "./styles/playground.css"

const root = document.getElementById("root")
if (!root) throw new Error("#root element not found")

ReactDOM.createRoot(root).render(
	<React.StrictMode>
		<BrowserRouter>
			<App />
			{/*
			 * Agentation — 로컬 개발 중에만 bottom-right 에 annotation toolbar 주입.
			 * UI 요소를 클릭 → 주석 작성 → Claude Code/Cursor 로 붙여넣을 구조화된 markdown 생성.
			 * 프로덕션 번들에는 포함되지 않음 (tree-shake by `import.meta.env.DEV`).
			 */}
			{import.meta.env.DEV && <Agentation />}
		</BrowserRouter>
	</React.StrictMode>
)
